exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.automation-btn[data-v-50309662]:active {\n  box-shadow: inset 0 1px 0 rgba(212, 220, 227, 0.7), inset 0 0 1px #d4dce3,\n    0 1px 0 #fff !important;\n  background: #f5f7f8 !important;\n}\n.automation-btn[data-v-50309662]:hover {\n  color: #666;\n}\n", ""]);

// exports
